// FilterSet.tsx
import React from 'react';
import { ButtonDropdown } from '@cloudscape-design/components';
import { UserViewPreferences } from '@amzn/controllershiphub-typescript-client';

export const FilterSet: React.FC<{
  filterViews: Record<string, UserViewPreferences>; // Updated type
  onFilterSetSelect: (viewName: string) => void;
  loading?: boolean;
  selectedView?: string;
}> = ({ filterViews, onFilterSetSelect, loading = false, selectedView = 'Select View' }) => {
  const regularViews: Array<{ id: string; text: string; disabled: boolean; selected: boolean }> =
    [];
  const sharedViews: Array<{ id: string; text: string; disabled: boolean; selected: boolean }> = [];

  // Add Default View if it's not currently selected
  if (selectedView !== 'Default View') {
    regularViews.push({
      id: 'Default View',
      text: 'Default View',
      disabled: false,
      selected: false,
    });
  }

  // Separate views into regular (personal) and shared
  Object.entries(filterViews).forEach(([viewName, viewPreferences]) => {
    if (viewName === 'Default View') return; // Skip Default View as it's handled separately

    const item = {
      id: viewName,
      text: viewName,
      disabled: false,
      selected: viewName === selectedView,
    };

    if (viewPreferences.shared) {
      sharedViews.push(item);
    } else {
      regularViews.push(item);
    }
  });

  // Create dropdown items
  const filterSetItems = [
    ...regularViews,
    ...(sharedViews.length > 0
      ? [
          {
            text: 'Shared Views',
            items: sharedViews,
          },
        ]
      : []),
  ];

  return (
    <ButtonDropdown
      data-testid="view-selection-dropdown"
      items={filterSetItems}
      onItemClick={({ detail }) => onFilterSetSelect(detail.id)}
      loading={loading}
    >
      {selectedView}
    </ButtonDropdown>
  );
};
